var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9399 45.5H15.9399C9.09994 45.5 6.43994 42.84 6.43994 36V20C6.43994 19.18 7.11994 18.5 7.93994 18.5H39.9399C40.7599 18.5 41.4399 19.18 41.4399 20V36C41.4399 42.84 38.7799 45.5 31.9399 45.5ZM9.43994 21.5V36C9.43994 41.16 10.7799 42.5 15.9399 42.5H31.9399C37.0999 42.5 38.4399 41.16 38.4399 36V21.5H9.43994Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39 21.5H9C5.5 21.5 3.5 19.5 3.5 16V14C3.5 10.5 5.5 8.5 9 8.5H39C42.4 8.5 44.5 10.6 44.5 14V16C44.5 19.4 42.4 21.5 39 21.5ZM9 11.5C7.18 11.5 6.5 12.18 6.5 14V16C6.5 17.82 7.18 18.5 9 18.5H39C40.76 18.5 41.5 17.76 41.5 16V14C41.5 12.24 40.76 11.5 39 11.5H9Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.2799 11.5H12.2399C11.8199 11.5 11.4199 11.32 11.1399 11.02C9.91994 9.68001 9.95994 7.62001 11.2399 6.34001L14.0799 3.50001C15.3999 2.18001 17.5799 2.18001 18.8999 3.50001L24.3399 8.94001C24.7599 9.36001 24.8999 10.02 24.6599 10.58C24.4399 11.14 23.8999 11.5 23.2799 11.5ZM13.3399 8.50001H19.6799L16.7799 5.62001C16.6199 5.46001 16.3599 5.46001 16.1999 5.62001L13.3599 8.46001C13.3599 8.48001 13.3399 8.48001 13.3399 8.50001Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.7399 11.5H24.6999C24.0999 11.5 23.5399 11.14 23.3199 10.58C23.0799 10.02 23.2199 9.38001 23.6399 8.94001L29.0799 3.50001C30.3999 2.18001 32.5799 2.18001 33.8999 3.50001L36.7399 6.34001C38.0199 7.62001 38.0799 9.68001 36.8399 11.02C36.5599 11.32 36.1599 11.5 35.7399 11.5ZM28.3399 8.50001H34.6799C34.6599 8.48001 34.6599 8.48001 34.6399 8.46001L31.7999 5.62001C31.6399 5.46001 31.3799 5.46001 31.2199 5.62001L28.3399 8.50001Z",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.8799 33.8C19.3199 33.8 18.7399 33.66 18.2199 33.38C17.0799 32.76 16.3799 31.58 16.3799 30.3V20C16.3799 19.18 17.0599 18.5 17.8799 18.5H29.9599C30.7799 18.5 31.4599 19.18 31.4599 20V30.26C31.4599 31.56 30.7599 32.74 29.6199 33.34C28.4799 33.96 27.0999 33.88 26.0199 33.16L24.2399 31.96C24.0799 31.84 23.8599 31.84 23.6799 31.96L21.7999 33.2C21.2199 33.6 20.5399 33.8 19.8799 33.8ZM19.3799 21.5V30.28C19.3799 30.54 19.5399 30.66 19.6399 30.72C19.7399 30.78 19.9399 30.84 20.1599 30.7L22.0399 29.46C23.2199 28.68 24.7399 28.68 25.8999 29.46L27.6799 30.66C27.8999 30.8 28.0999 30.74 28.1999 30.68C28.2999 30.62 28.4599 30.5 28.4599 30.24V21.48H19.3799V21.5Z",
    fill: "#080808"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.4a37cbe6d7d393185db1f2cbc127493f.svg";
export { ForwardRef as ReactComponent };